















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Blocks from "./blocks.vue";

@Component({
  components: {
    Blocks,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;
  @Prop() grounds!: any[];
}
